module.exports = __webpack_public_path__ + "static/media/logo_without_label.92da21bf.png";